import { combineReducers } from 'redux';
import account from './account/reducers';
import app from './app/reducers';

const rootReducer = combineReducers({ account, app });

export default rootReducer;
